import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-721aad1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-search d-none d-md-flex flex-1 align-items-center mx-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons mr-2" }, "menu", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Categorías ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "input-group btn-rounded bg-white" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bg-gray mt-auto mb-auto separator" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "search-input",
    type: "submit",
    class: "btn btn-primary btn-icon btn-rounded shadow-none px-3 py-2"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "material-icons mr-2" }, "search"),
    /*#__PURE__*/_createTextVNode(" Buscar ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    method: "GET",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.goToSearch()), ["prevent"])),
    action: "/search",
    class: "d-lg-block flex-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePanel && _ctx.togglePanel(...args))),
        id: "btn-category-desktop",
        type: "button",
        class: _normalizeClass(["btn btn-icon btn-rounded shadow-none mr-3 px-3 py-2", _ctx.showPanel? 'btn-white text-primary pb-5 opened' : 'btn-primary'])
      }, _hoisted_4, 2),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.local.searching) = $event)),
          type: "text",
          class: "form-control h-auto border-0",
          placeholder: "Buscar productos, servicios y más..."
        }, null, 512), [
          [_vModelText, _ctx.local.searching]
        ]),
        _hoisted_6,
        _hoisted_7
      ])
    ])
  ], 32))
}